export default __webpack_public_path__ + "./fonts/info.4e91300a.svg";